import React, { FunctionComponent } from "react";
import { Theme, makeStyles, Grid, useTheme } from "@material-ui/core";
import { BeatLoader } from "react-spinners";

const useStyles = makeStyles((theme: Theme) => ({
  container: {
    position: "absolute",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
  },
}));

interface IThreeLoadingIndicatorProps {}

export const ThreeLoadingIndicator: FunctionComponent<IThreeLoadingIndicatorProps> = (props) => {
  const classes = useStyles();
  const theme = useTheme();
  return (
    <Grid container justify="center" alignItems="center" className={classes.container}>
      <BeatLoader color={theme.palette.primary.main} />
    </Grid>
  );
};
